import React from "react";
import Header from "../components/header/Header";
import WorkExperience from "./workExperience/WorkExperience";
import Footer from "../components/footer/Footer";
import ScrollToTopButton from "./topbutton/Top";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";

const ExperiencePage = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        <Header />
        <WorkExperience />
        <Footer />
        <ScrollToTopButton />
      </StyleProvider>
    </div>
  );
};

export default ExperiencePage;

